var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenSuccessTickRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 27.5,
    r: 27.5,
    fill: "#6D8752"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11587_107030)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5828 17.2331C43.0124 17.6521 43.2538 18.2203 43.2538 18.8128C43.2538 19.4052 43.0124 19.9735 42.5828 20.3925L25.406 37.1399C25.179 37.3612 24.9095 37.5368 24.6129 37.6566C24.3163 37.7764 23.9984 37.8381 23.6773 37.8381C23.3563 37.8381 23.0383 37.7764 22.7417 37.6566C22.4451 37.5368 22.1756 37.3612 21.9486 37.1399L13.4145 28.8205C13.1956 28.6144 13.021 28.3679 12.9009 28.0953C12.7808 27.8227 12.7176 27.5295 12.7149 27.2328C12.7123 26.9361 12.7703 26.6419 12.8855 26.3673C13.0007 26.0927 13.1709 25.8432 13.3861 25.6334C13.6012 25.4236 13.8571 25.2577 14.1387 25.1454C14.4204 25.033 14.7221 24.9765 15.0264 24.9791C15.3307 24.9817 15.6314 25.0433 15.911 25.1604C16.1906 25.2775 16.4435 25.4477 16.6549 25.6611L23.6765 32.5072L39.3409 17.2331C39.5537 17.0254 39.8064 16.8607 40.0845 16.7483C40.3626 16.636 40.6608 16.5781 40.9618 16.5781C41.2629 16.5781 41.561 16.636 41.8391 16.7483C42.1173 16.8607 42.37 17.0254 42.5828 17.2331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11587_107030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.6667,
    height: 35.75,
    fill: "white",
    transform: "translate(9.66406 9.625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSuccessTickRounded);
export default __webpack_public_path__ + "static/media/green-success-tick-rounded.c4d0e4055c1fa69b8569a1dca6551314.svg";
export { ForwardRef as ReactComponent };